import React, { useEffect, useRef } from "react";

import { ChatMessageItem } from "./ChatMessageItem";

import { useReportingChatStore } from "../store";

const EmptyState: React.FC = () => (
	<div className="flex h-full flex-col items-center justify-center px-4 text-center text-neutral-500">
		<p className="text-lg font-medium text-neutral-700">Ask a question about your data</p>
		<p className="mt-1 max-w-md text-sm">
			Get a direct answer, a table, or a chart — drawn from your real review, goal, survey, and employee data.
		</p>
	</div>
);

export const ChatMessages: React.FC<{
	sendQuery: (query: string) => Promise<void>;
	isStreaming: boolean;
	// True while a reopened artifact's GET is in flight — the suggestion chips are a second door
	// onto sendQuery, so they need the same artifact-load gate as ChatInput, independently of
	// isStreaming.
	isDisabled?: boolean;
}> = ({ sendQuery, isStreaming, isDisabled = false }) => {
	const messages = useReportingChatStore((state) => state.messages);
	const error = useReportingChatStore((state) => state.error);
	const bottomRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
	}, [messages]);

	return (
		<div className="flex-1 overflow-y-auto py-4">
			{error && (
				<div className="mx-auto max-w-3xl px-4">
					<div className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
						{error}
					</div>
				</div>
			)}
			{messages.length === 0 ? (
				<EmptyState />
			) : (
				messages.map((message) => (
					<ChatMessageItem
						key={message.id}
						message={message}
						onSuggestionClick={sendQuery}
						suggestionsDisabled={isStreaming || isDisabled}
					/>
				))
			)}
			<div ref={bottomRef} />
		</div>
	);
};

export default ChatMessages;
